import {TransportCardBalance} from '../../../../shared/models/api/transportCardBalance';
import {createSlice, PayloadAction, SliceCaseReducers} from '@reduxjs/toolkit';
import {AppActions} from '../../../actions';

export interface CardBalanceState {
  data: TransportCardBalance | null;
  isLoaded: boolean;
}

const initialState: CardBalanceState = {
  data: null,
  isLoaded: false,
};

export const cardBalanceSlice = createSlice<CardBalanceState, SliceCaseReducers<CardBalanceState>>({
  name: '@@eskmo/transportCard/cardBalance',
  initialState,
  reducers: {
    setData: (state, action: PayloadAction<TransportCardBalance>) => {
      state.data = action.payload;
    },
    setLoaded: (state, action: PayloadAction<boolean>) => {
      state.isLoaded = action.payload;
    },
    reset: () => {
      return initialState;
    },
  },
  extraReducers: {
    [AppActions.Reset]: () => {
      return initialState;
    },
  },
});
